import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import { loadLanguageAsync, routerSetLanguage } from './i18n/i18n-controller/i18n.js'


Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: process.env.VUE_APP_ROUTER_HOME,
      component: Home
    },
    {
      path: '/' + process.env.VUE_APP_ROUTER_GAME,
      name: process.env.VUE_APP_ROUTER_GAME,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "game" */ './views/Game.vue')
    },
    {
      path: '/' + process.env.VUE_APP_ROUTER_NEWS,
      name: process.env.VUE_APP_ROUTER_NEWS,
      component: () => import('./views/News.vue')
    },
    {
      path: '/' + process.env.VUE_APP_ROUTER_DEPOSIT,
      name: process.env.VUE_APP_ROUTER_DEPOSIT,
      component: () => import('./views/Deposit.vue')
    },
    {
      path: '/' + process.env.VUE_APP_ROUTER_CODAPAY,
      name: process.env.VUE_APP_ROUTER_CODAPAY,
      component: () => import('./views/Codapay.vue')
    },
    {
      path: '/' + process.env.VUE_APP_ROUTER_DEPOSIT_HISTORY_LIST,
      name: process.env.VUE_APP_ROUTER_DEPOSIT_HISTORY_LIST,
      component: () => import('./views/DepositHistoryList.vue')
    },
    {
      path: '/' + process.env.VUE_APP_ROUTER_CONTACT_US,
      name: process.env.VUE_APP_ROUTER_CONTACT_US,
      component: () => import('./views/ContactUs.vue')
    },
    {
      path: '/' + process.env.VUE_APP_ROUTER_DOWNLOAD,
      name: process.env.VUE_APP_ROUTER_DOWNLOAD,
      component: () => import('./views/Download.vue')
    },
    {
      path: '/' + process.env.VUE_APP_ROUTER_FAQ,
      name: process.env.VUE_APP_ROUTER_FAQ,
      component: () => import('./views/Faq.vue')
    },
    {
      path: '/' + process.env.VUE_APP_ROUTER_FAQ_NEW,
      name: process.env.VUE_APP_ROUTER_FAQ_NEW,
      component: () => import('./views/Faq_new.vue')
    },
    {
      path: '/' + process.env.VUE_APP_ROUTER_HISTORY_LIST,
      name: process.env.VUE_APP_ROUTER_HISTORY_LIST,
      component: () => import('./views/HistoryList.vue')
    },
    {
      path: '/' + process.env.VUE_APP_ROUTER_TERMS_OF_SERVICE,
      name: process.env.VUE_APP_ROUTER_TERMS_OF_SERVICE,
      component: () => import('./views/footer/' + process.env.VUE_APP_ROUTER_TERMS_OF_SERVICE + '.vue')
    },
    {
      path: '/' + process.env.VUE_APP_ROUTER_PRIVACY_POLICY,
      name: process.env.VUE_APP_ROUTER_PRIVACY_POLICY,
      component: () => import('./views/footer/' + process.env.VUE_APP_ROUTER_PRIVACY_POLICY + '.vue')
    },
    {
      path: '/' + process.env.VUE_APP_ROUTER_COOPERATION_PROPOSAL,
      name: process.env.VUE_APP_ROUTER_COOPERATION_PROPOSAL,
      component: () => import('./views/footer/' + process.env.VUE_APP_ROUTER_COOPERATION_PROPOSAL + '.vue')
    },
    {
      path: '/' + process.env.VUE_APP_ROUTER_INTRO,
      name: process.env.VUE_APP_ROUTER_INTRO,
      component: () => import('./views/footer/' + process.env.VUE_APP_ROUTER_INTRO + '.vue')
    },
    {
      path: '/' + process.env.VUE_APP_ROUTER_CHANGE_MEMBER,
      name: process.env.VUE_APP_ROUTER_CHANGE_MEMBER,
      component: () => import('./views/' + process.env.VUE_APP_ROUTER_CHANGE_MEMBER + '.vue')
    },
    {
      path: '/' + process.env.VUE_APP_ROUTER_INVOICE,
      name: process.env.VUE_APP_ROUTER_INVOICE,
      component: () => import('./views/Invoice.vue')
    },
    {
      path: '/' + process.env.VUE_APP_ROUTER_QUICKDEPOSIT,
      name: process.env.VUE_APP_ROUTER_QUICKDEPOSIT,
      component: () => import('./views/QuickDeposit.vue')
    },
    {
      path: '/' + process.env.VUE_APP_ROUTER_TOPUP,
      name: process.env.VUE_APP_ROUTER_TOPUP,
      component: () => import('./views/TopUp.vue')
    }
    /*
    {
      path: '/' + process.env.VUE_APP_ROUTER_GIFTCODE,
      name: process.env.VUE_APP_ROUTER_GIFTCODE,
      component: () => import('./views/GiftCode.vue')
    }
    */
  ]
})


router.beforeEach((to, from, next) => {
  let enforceChangeLanguage = ((to.query.lang!=undefined && to.query.lang!="") ? to.query.lang : "")
  const clientLanguage = navigator.language;
  routerSetLanguage(clientLanguage, enforceChangeLanguage).then(() => next());
})

export default router